import alexStates from 'a/components/GameHeader/AlexStates';
import { GAME_ID, REDUX_ACTIONS, VO_PROMPTS } from '../../data/constants';

const initialState = {
  alexState: 0,
  isRenderingHeaderInActivity: true,

  currentVOPrompt: VO_PROMPTS.NONE,
};

const gameHeaderReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        alexState: alexStates.INACTIVE,
        isRenderingHeaderInActivity: true,
      };

    case REDUX_ACTIONS.SET_ALEX_STATE:
      return {
        ...state,
        alexState: payload,
      };
    case REDUX_ACTIONS.SET_CURRENT_VO_PROMPT:
      return {
        ...state,
        currentVOPrompt: payload,
      };

    case REDUX_ACTIONS.SET_IS_RENDERING_HEADER_IN_ACTIVITY:
      return {
        ...state,
        isRenderingHeaderInActivity: payload,
      };

    default:
      return state;
  }
};

export default gameHeaderReducer;
